import type {
  FlowBuilderAgentState,
  FlowBuilderTurn,
  FlowBuilderTurnActivity,
} from '../../types/flowBuilder/flowBuilderState';
import type { FlowBuilderNewTurnInput } from '../../types/flowBuilder/flowBuilderStore';

const createFlowBuilderTurnActivity = (): FlowBuilderTurnActivity => ({
  toolCalls: [],
  createdResources: [],
  completedFlows: [],
  repairIssues: [],
  guidance: [],
  simulations: [],
});

export const createFlowBuilderTurn = ({
  turnId,
  sessionId,
  userMessage,
  startRevision,
}: FlowBuilderNewTurnInput): FlowBuilderTurn => ({
  turnId,
  sessionId,
  phase: 'streaming',
  userMessage,
  startRevision,
  lastEventId: null,
  streamingText: '',
  thinkingLabel: null,
  activity: createFlowBuilderTurnActivity(),
  build: { drawingFlowId: null, drawingFlowName: null, createdNodes: 0, totalNodes: 0 },
  draftConflict: null,
  failure: null,
});

export const createFlowBuilderAgentState = (): FlowBuilderAgentState => ({
  sessions: { items: [], page: 0, total: 0, hasMore: false, status: 'idle', error: null },
  sessionCreation: { status: 'idle', error: null },
  chat: {
    sessionId: null,
    messages: [],
    nextBeforeSeq: null,
    hasMore: false,
    status: 'idle',
    error: null,
  },
  pendingInterview: null,
  turn: null,
  previews: {},
  serverReloads: { agent: 0, byFlowId: {} },
  unconfirmedTurn: null,
});

/** Referência estável para o selector de um agente que ainda não usou o FlowBuilder. */
export const EMPTY_FLOW_BUILDER_AGENT_STATE: FlowBuilderAgentState = createFlowBuilderAgentState();
